var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-rename-diag"},[_c('upload-diag',{attrs:{"isShow":_vm.isShow,"title":_vm.title,"uploadaction":_vm.uploadaction},on:{"close":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }